import { api } from '@/lib/api';
import type {
  CreateUserInviteRequest,
  UserInvite,
} from '@/api/generated/types.gen';

export interface CreateInviteArgs {
  body: CreateUserInviteRequest;
  idempotencyKey?: string;
}

export function createInvite({
  body,
  idempotencyKey,
}: CreateInviteArgs): Promise<UserInvite> {
  return api<UserInvite>('/api/v1/users/invites', {
    method: 'POST',
    body,
    headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
  });
}
